import { openApprovalRequiredModal } from '../actions/modalActions';

// Bridge between the axios response interceptor (which lives outside React) and
// the Redux store. The store is not exported as a singleton, so a connected
// component (UtilsComponent) registers `dispatch` here on mount and the
// interceptor uses it to open the "Approval required" modal.
let _dispatch = null;

export const registerApprovalDispatch = (dispatch) => {
  _dispatch = dispatch;
};

// Called by the HTTP interceptor when a guarded action returns
// `403 approval-required`. `meta` is the envelope's `meta` block.
export const notifyApprovalRequired = (meta = {}) => {
  if (_dispatch) {
    _dispatch(openApprovalRequiredModal(meta));
  }
};
